import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  errorMessage: string = '';
  userName: string = '';
  screenCode: string = '';
  tiles = [
    { text: 'Shortcut 1', cols: 3, rows: 1, color: 'lightblue' },
    { text: 'Shortcut 2', cols: 1, rows: 2, color: 'lightgreen' },
    { text: 'Shortcut 3', cols: 1, rows: 1, color: 'lightpink' },
    { text: 'Shortcut 4', cols: 2, rows: 1, color: '#DDBDF1' },
  ];

  constructor(private userSvc: UserService) { }

  ngOnInit() {
    let user = this.userSvc.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

}
